export interface StorageEstimate { quota: number; usage: number; }

export async function getStorageEstimate(): Promise<StorageEstimate> {
  const s = (navigator as Navigator).storage;
  if (s === undefined || typeof s.estimate !== "function") return { quota: 0, usage: 0 };
  try {
    const e = await s.estimate();
    return { quota: e.quota ?? 0, usage: e.usage ?? 0 };
  } catch { return { quota: 0, usage: 0 }; }
}

/** True if estimatedBytes plus a 10% headroom margin fits in the remaining
 *  quota. The margin defends against eviction-on-near-full and the fact that
 *  StorageEstimate is rounded. */
export async function hasSpaceFor(estimatedBytes: number): Promise<boolean> {
  const { quota, usage } = await getStorageEstimate();
  if (quota === 0) return true; // unknown — let the put attempt fail loudly
  const free = quota - usage;
  return estimatedBytes <= free * 0.9;
}
